import type { createApp } from 'vue';
import type { WidgetInstance } from './types';

export interface WidgetRecord {
  app: ReturnType<typeof createApp>;
  instance: WidgetInstance;
}

export const widgetInstances = new Map<HTMLElement, WidgetRecord>();
